import { isNotEmpty } from "./langUtils";

export function formatSystemDetails(system: $TSFixMe) {
  let details = system.typeName;
  if (isNotEmpty(system.description)) {
    details = details.concat(", ").concat(system.description);
  }
  return details;
}
